/// <reference path="../core/models/complaint/complaint-comment.ts" />
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { SpinnerService } from '../core/spinner/spinner.service';
import { catchError, finalize, map } from 'rxjs/operators';
import { ExceptionService } from '../core/services/exception.service';
import { CONFIG } from '../core/config';
import { ComplaintModel } from '../core/models/complaint/complaint.model';
import { SearchComplaints } from '../core/models/complaint/search-complaints-list';
import { PagedResultModel } from '../core/models/paged-result.model';
import { ComplaintDetail } from '../core/models/complaint/complaint-detail';
import { ComplaintComment } from '../core/models/complaint/complaint-comment';
import { Images } from '../core/models/complaint/images';
import { DropdownItem } from '../core/models/dropdown-item';
import { formatDate } from '@angular/common';
import { SystemNotification } from '../core/models/complaint/system-notification';

@Injectable({
    providedIn: 'root'
})
export class ComplaintsService {

    constructor(private _http: HttpClient,
        private _spinnerService: SpinnerService,
        private _exceptionService: ExceptionService) { }

    reportProblem(formData: FormData): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.saveComplaint, formData)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
        );
    }

    sendSystemNotificationEmailToAdmins(id: SystemNotification): Observable<boolean> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.sendSystemNotificationEmailToAdmins, id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    sendSystemNotificationSMSToAdmins(id: SystemNotification): Observable<boolean> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.sendSystemNotificationSMSToAdmins, id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    //uploadImage(formData): Observable<number> {
    //    this._spinnerService.show();
    //    return this._http.post<number>(CONFIG.baseUrls.complaint.uploadImages, formData)
    //        .pipe(
    //            catchError(this._exceptionService.catchBadResponse),
    //            finalize(() => this._spinnerService.hide())
    //        );
    //}

    getImagesByComplaintID(complaintID: number): Observable<Images[]> {
        this._spinnerService.show();
        return this._http.get<Images[]>(CONFIG.baseUrls.complaint.getImagesByComplaintID + complaintID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }


    getComplaintByID(id: number, langID: number): Observable<ComplaintDetail> {
        this._spinnerService.show();
        return this._http.get<ComplaintDetail>(CONFIG.baseUrls.complaint.getComplaintByID + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getMyComplaintByID(id: number, langID: number): Observable<ComplaintDetail> {
        this._spinnerService.show();
        return this._http.get<ComplaintDetail>(CONFIG.baseUrls.complaint.getMyComplaintByID + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    searchComplaints(searchModel: SearchComplaints): Observable<PagedResultModel> {
        this._spinnerService.show();
        return this._http.post<PagedResultModel>(CONFIG.baseUrls.complaint.getAllComplaints, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    searchComplaintsByUserID(searchModel: SearchComplaints): Observable<PagedResultModel> {
        this._spinnerService.show();
        return this._http.post<PagedResultModel>(CONFIG.baseUrls.complaint.getAllComplaintsByUserID, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    deleteComplaintImage(id: number): Observable<boolean> {
        this._spinnerService.show();
        return this._http.delete<boolean>(CONFIG.baseUrls.complaint.deleteComplaintImage + id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getImagesIDByComplaintID(complaintID: number): Observable<any> {
        this._spinnerService.show();
        return this._http.get<any>(CONFIG.baseUrls.complaint.getImagesIDByComplaintID + complaintID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getImageByID(id: number): Observable<string> {
        this._spinnerService.show();
        return this._http.get<string>(CONFIG.baseUrls.complaint.getImageByID + id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadFile(id: number, langID: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.complaint.downloadFile, { ID: id, LangID: langID }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    addNewComplaintComment(newComment: ComplaintComment): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.addNewComplaintComment, newComment)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    uploadComplaintCommentFiles(formData): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.uploadCommentFiles, formData)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
        );

     
    }

    downloadAnswerFile(id: number, langID: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.complaint.downloadAnswerFile, { ID: id, LangID: langID }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getNumberOfComplaintByCategory(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintByCategory, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getNumberOfComplaintByOrganization(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintByOrganization, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
        );
    }
    getNumberOfComplaintByStatus(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintByStatus, data)
                .pipe(
                    catchError(this._exceptionService.catchBadResponse),
                    finalize(() => this._spinnerService.hide())
                );
        
        }
    getNumberOfComplaintByYear(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintsByMonth, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }

    getNumberOfComplaintsBYCategoryPerYear(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintsBYCategoryPerYear, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }

    getNumberOfResolvedComplaintsBYCategoryByHours(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfResolvedComplaintsBYCategoryByHourslangID, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }

    getNumberOfComplaintsByGender(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintsByGender,data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }

    getNumberOfComplaintsBySensitiveCategory(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintsBySensitiveCategory, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }
    numberOfComplaintsByYearGroup(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.numberOfComplaintsByYearGroup,data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }
    getNumberOfComplaintsByCategoryAndGender(data: any): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.complaint.getNumberOfComplaintsByCategoryAndGender, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );

    }
}
